import { jsxs as r, jsx as o } from "react/jsx-runtime";
import { CloseIcon as c } from "../../../assets/svgs/CloseIcon.js";
const l = ({
  stepNumber: e,
  totalSteps: t,
  onClose: i
}) => /* @__PURE__ */ r("div", { className: "tooltip-header", children: [
  /* @__PURE__ */ o("span", { children: `${e} de ${t}` }),
  /* @__PURE__ */ o("button", { onClick: () => i("Botão Fechar"), children: /* @__PURE__ */ o(c, { width: 16, height: 16 }) })
] });
export {
  l as TooltipHeader
};
